import { Box, Typography } from '@mui/material';
import { FC } from 'react';

type SeekHoverControllerProps = {
  value: {
    position: number;
    value: string;
  };
};

export const SeekHoverController: FC<SeekHoverControllerProps> = ({ value }) => {
  const { position, value: timestamp } = value;

  return (
    <Box
      sx={{
        display: 'inline-block',
        height: '0px',
        position: 'relative',
      }}
    >
      <Box
        sx={({ palette }) => ({
          display: 'inline-block',
          position: 'absolute',
          bottom: '0px',
          left: position,
          transform: 'translateX(-50%)',
          zIndex: '1',
          color: palette.common.white,
          backgroundColor: palette.primary.main,
          opacity: 0.7,
          padding: '8px',
          borderRadius: '8px',
        })}
      >
        <Typography color="white" variant="p16">
          {timestamp}
        </Typography>
      </Box>
    </Box>
  );
};
